import Vue from 'vue/dist/vue.min.js';
import store from './store';
import EventBus from './event-bus';
import axios from 'axios';
import { getUrlParameter } from './misc';
import showdown from 'showdown';
import "regenerator-runtime/runtime";

const searchResults = () => {

    let search = document.querySelectorAll('.search-results');

    const searchResultsConstructor = (id) => {
        var converter = new showdown.Converter({ disableForced4SpacesIndentedSublists: true, openLinksInNewWindow: true });
        converter.setOption('tables', true);

        Vue.component('search-results-template', {
            data: function () {
                return {
                    data: {
                        inputQuery: null,
                        query: null,
                        currentPage: 1, //current page #
                        filtersVisible: null, //are filters visible
                        filterAreaVisible: true,
                        filters: [],
                        results: [],
                        totalResults: null,
                        savedDocs: [], //bookmarked items
                        savedDocsLabel: null, //label for saved docs
                        isMobile: null,
                        urlParams: null, //for deeplinking in-browser
                        counts: {},
                        store: store,
                        didYouMean: null,
                        resultsReturned: null,
                        class: 'search-results',
                        ai_inputTitle: "",
                        ai_related_questions: [],
                        ai_sources: [],
                        ai_chat_doc_id: "",
                        ai_raw_response: "",
                        ai_response: "",
                        ai_disclaimer: "",
                        ai_status_ai_stop: true,
                        ai_status_call_fail: false,
                        ai_status_show_more: false,
                        ai_status_clicked_unlike: false,
                        ai_status_clicked_like: false,
                        ai_status_final_result: false,
                        aiSearchDescHeight: -1,
                        rerenderShowMore: 0,
                        manageNoResultsOnFirstLoad: false,
                        aiSearchEnabled: window.aiSearchEnabled,
                        isFeedbackDisabled: true,
                        ai_feedback_text: "",
                        ai_status_feedback_submitted: false,
                        ai_status_feedback_submitted_error: false,
                        ai_status_done: false,
                    },
                    isLoading: null
                }
            },
            computed: {
                computedIsMobile: function () {
                    return store.state.isMobile;
                },
                saved: function () {
                    return store.state.favorites;
                },
                taggingMetaL1: function () {
                    return JSON.stringify({
                        "type": "search-results",
                        "category": "Search",
                        "action": this.data.query,
                        "label": this.data.totalResults || 0,
                        "content": "Hero",
                        "title": "Search Results",
                        "name": "Hero - Search Results",
                        "no": "01"
                    })
                },
                taggingMetaL2: function () {
                    return JSON.stringify({
                        "type": "search-results",
                        "category": "Search",
                        "action": this.data.query,
                        "label": this.data.totalResults || 0,
                    })
                },
                taggingTrigger: function () {
                    return this.data.resultsReturned ? "trigger" : null
                },
            },
            watch: {
                saved: function () {
                    let allSaved = [];
                    let saved = store.state.favorites;

                    for (let prop in saved) {
                        allSaved = [...allSaved, ...saved[prop]];
                    }

                    this.data.savedDocs = allSaved.filter((item) => {
                        return item !== ""
                    });
                },
                computedIsMobile: function () {
                    this.data.isMobile = this.computedIsMobile;
                    this.data.filtersVisible = !this.computedIsMobile ? true : this.data.filtersVisible;

                    this.initSubmit();
                },
                "data.filters": function () {
                    //console.log(this.data.filters);
                    this.data.currentPage = 1; //reset page to 1
                    this.addLoading();
                    this.getResults(); // handle api call
                },
                "data.query": function () {
                    this.data.currentPage = 1; //reset page to 1 when query changes
                    // this.getResults(this.data.query);
                }
            },
            methods: {
                toggleFilters() {
                    if (this.data.isMobile) {
                        this.data.filtersVisible = !this.data.filtersVisible;
                    }
                },
                updateFilters(el, e, type) {
                    if (el !== 'search') {
                        return;
                    }

                    var type = type;
                    var value = encodeURIComponent(e.currentTarget.value);
                    var checked = e.currentTarget.checked;
                    // console.log("type", type)
                    // console.log(e.currentTarget.name);
                    // console.log("value", encodeURIComponent(e.target.value));
                    // console.log("checked",e.target.checked);

                    if (checked) {
                        if (type !== "savedDocuments") {
                            this.data.filters = [...this.data.filters, { "value": value, "type": type, "name": e.currentTarget.name }];
                        } else {
                            this.data.filters = [...this.data.filters, { "value": checked, "type": type, "name": e.currentTarget.name }];
                        }
                    } else {
                        let index = this.data.filters.map((e) => {
                            return e.value
                        }).indexOf(value);
                        // console.log("INDEX", index);
                        this.data.filters.splice(index, 1);
                    }
                },
                // removes specific filter
                removeFilter(el, value, type) {
                    if (el !== this.data.class) { return; };
                    //console.log("remove", value);
                    let index = this.data.filters.map((e) => {
                        return e.value
                    }).indexOf(value);
                    this.data.filters.splice(index, 1);
                },
                // clears filters
                removeAll() {
                    this.data.filters = [];
                },
                addLoading() {
                    this.isLoading = true;

                    let inputField = document.querySelectorAll('.search-results__input-container');
                    inputField.forEach(element => element.classList.add('loading'));
                },
                removeLoading() {
                    this.isLoading = false;

                    let inputField = document.querySelectorAll('.search-results__input-container');
                    inputField.forEach(element => element.classList.remove('loading'));
                },
                // AI SEARCH
                aiShowMore() {
                    if (window && window.dataLayer) {
                        window.dataLayer.push({
                            "event": "click",
                            "type": "accordion",
                            "category": "Show More",
                            "action": "AI Search Box",
                            "label": "Expand",
                            "responseType": "AI Response"
                        });
                    }
                    this.data.ai_status_show_more = true;
                },
                aiFeedbackUnlike() {
                    this.aiFeedbackCall(1);
                    this.data.isFeedbackDisabled = false;
                },
                aiFeedbackLike() {
                    this.aiFeedbackCall(2);
                    this.data.isFeedbackDisabled = false;
                },
                aiFeedbackCall(type) {
                    if (type == 1) {
                        this.data.ai_status_clicked_unlike = true;
                        this.data.ai_status_clicked_like = false;
                    }
                    else if (type == 2) {
                        this.data.ai_status_clicked_like = true;
                        this.data.ai_status_clicked_unlike = false;
                    }
                },
                aiFeedbackSubmit() {
                    let self = this;
                    var beaconFeedback = "/api/beaconfeedback";
                    // var beaconFeedback = "http://localhost:3003/beaconfeedback";

                    axios.patch(beaconFeedback, {
                        docId: this.data.ai_chat_doc_id,
                        rating: this.data.ai_status_clicked_unlike ? 1 : 5,
                        feedback: this.data.ai_feedback_text,
                    }).then(function (response) {
                        if (response.data.success) {
                            if (window && window.dataLayer) {
                                window.dataLayer.push({
                                    "event": "click",
                                    "type": "feedback",
                                    "category": "Feedback",
                                    "action": self.data.ai_status_clicked_unlike ? 1 : 5,
                                    "label": self.data.ai_status_clicked_unlike ? 1 : 5,
                                    "userComment": self.data.ai_feedback_text ? "Yes" : "No",
                                    "responseType": "AI Response"
                                });
                            }
                            
                            self.data.ai_status_feedback_submitted = true;
                        }
                        else {
                            console.log("Beacon feedback request error message: " + response.data.message);
                            self.data.ai_status_feedback_submitted_error = true;
                        }
                    }).catch(function (error) {
                        console.log("Unable to submit user feedback: " + error);
                        self.data.ai_status_feedback_submitted_error = true;
                    });
                },
                async getResults() {
                    // AI Search - avoid showing tip and generating at loading without a previous search
                    this.data.ai_status_ai_stop = false;

                    // this.data.query = query ? query : null;
                    this.data.resultsReturned = true; //set this once after initial results returned
                    let baseUrl = window.searchAPIUrl;

                    if (this.data.inputQuery == 'test no results') { // FOR TESTING ONLY
                        baseUrl = 'http://localhost:3003/searchResultsNone';
                    }

                    let apiUrl = `${baseUrl}${baseUrl.indexOf('?') > -1 ? '' : '?'}`;
                    // let apiUrl = "http://localhost:3003/searchResults"; //from json-server
                    let self = this;

                    let savedDocumentsTrueParams = () => {
                        var savedOnly = this.data.filters.find(item => {
                            return item.type == "savedDocuments";
                        })
                        if (savedOnly) {
                            return true;
                        } else {
                            return false;
                        }
                    }

                    var filters = [];

                    this.data.filters.map((item) => {
                        if (item.value !== true && item.value !== false) {
                            filters.push(item.value);
                        }
                    });

                    let filtersStr = decodeURIComponent(filters.join('|'));
                    // console.log(filtersStr);

                    let axiosParams = {
                        q: this.data.inputQuery ? this.data.inputQuery : this.data.query ? this.data.query : null,
                        filters: filtersStr == "" ? null : filtersStr,
                        savedDocuments: savedDocumentsTrueParams() ? savedDocumentsTrueParams() : null,
                        saved: savedDocumentsTrueParams() ? this.data.savedDocs.join('|') : null,
                        page: this.data.currentPage
                    }

                    this.data.axiosParams = axiosParams;

                    var searchTerm = axiosParams.q;

                    // console.log(axiosParams);
                    axios.get(apiUrl, {
                        params: {
                            ...axiosParams
                        }
                    })
                        .then(function (response) {
                            // console.log(response);
                            ///
                            /// Did you mean query logic from episerver find:
                            ///
                            let didyoumeanEl, didyoumeanContainer;

                            if (response.data.results.length == 0) {
                                didyoumeanEl = document.querySelectorAll('.global__didyoumean');
                                didyoumeanContainer = document.querySelectorAll('.search-results__input-container__didyoumean');

                                self.data.filterAreaVisible = false;
                            }
                            else {
                                didyoumeanEl = document.querySelectorAll('.global__peoplealsosearchedfor');
                                didyoumeanContainer = document.querySelectorAll('.search-results__input-container__peoplealsosearchedfor');

                                self.data.filterAreaVisible = true;
                            }
                            if (response.data.didYouMean && response.data.didYouMean.length > 0) {
                                let allElements = [];

                                response.data.didYouMean.forEach(dym => {
                                    let anchorElement = document.createElement('a');
                                    anchorElement.href = `?q=${dym}`;
                                    anchorElement.innerText = dym;
                                    //anchorElement.addEventListener("click", function (e) {
                                    //    self.didYouMean(e);
                                    //    didyoumeanContainer.forEach(element => element.classList.remove('show'));
                                    //});
                                    allElements.push(anchorElement);
                                })
                                //clear out all previous elements
                                didyoumeanEl.forEach(parent => {
                                    while (parent.firstChild) {
                                        parent.removeChild(parent.firstChild);
                                    }
                                });
                                for (let i = 0; i < allElements.length; i++) {
                                    didyoumeanEl.forEach(el => {
                                        let anchorElement = allElements[i].cloneNode(true);
                                        anchorElement.addEventListener("click", function (e) {
                                            e.stopPropagation();
                                            self.didYouMean(e);
                                            //didyoumeanContainer.forEach(element => element.classList.remove('show'));
                                        });

                                        el.append(anchorElement);
                                    });
                                    if (i + 1 < allElements.length) {
                                        var commaEl = document.createElement('span');
                                        //commaEl.innerText = ' ';
                                        commaEl.style.paddingLeft = "7px";
                                        didyoumeanEl.forEach(el => {
                                            el.append(commaEl.cloneNode(true));
                                        });
                                    }
                                }

                                didyoumeanContainer.forEach(element => element.classList.add('show'));
                            } else {
                                didyoumeanContainer.forEach(element => element.classList.remove('show'));
                            }
                            ///
                            /// End of did you mean query logic
                            ///

                            if (response.data.results) {
                                // construct site section label into the title
                                self.data.results = response.data.results.map((item) => {
                                    if (item.title && item.filterText) {
                                        if (item.title.indexOf("<p>") > -1) {
                                            return {
                                                ...item,
                                                "title": `<p>${item.title.replace("<p>", "")}`,
                                                "rawTitle": item.title
                                            }
                                        } else {
                                            return {
                                                ...item,
                                                "title": `${item.title}`,
                                                "rawTitle": item.title
                                            }
                                        }
                                    } else {
                                        return { ...item }
                                    }
                                });
                                //if (!(response.data.results.length > 0)) {
                                //self.data.didYouMean = response.data.didYouMean;
                                //} else {
                                self.data.didYouMean = null;
                                //}
                                self.data.manageNoResultsOnFirstLoad = true;
                            } else {
                                self.data.results = null;
                                self.data.manageNoResultsOnFirstLoad = true;
                            }

                            // GTM TAGGING
                            if (searchTerm && searchTerm.length > 0 && window.dataLayer &&
                                window.dataLayer[window.dataLayer.length - 1].event != "search-results" // hack to avoid double entry.  this runs twice for some reason
                            ) { // only push if this is a query, not a filter
                                window.dataLayer.push({
                                    event: "search-results",
                                    type: "global",
                                    category: "Search",
                                    action: searchTerm,
                                    label: response.data.totalResults,
                                });
                            }

                            // self.data.results = response.data.results ? response.data.results : null; 
                            self.data.totalResults = response.data.totalResults;

                            // get counts of search result types
                            self.data.counts = response.data.filterCountResults;
                            self.data.trackId = response.data.trackId;
                            // console.log(response.data);

                            self.removeLoading();
                        })
                        .catch(function (error) {
                            console.log(error);
                            self.removeLoading();
                        });

                    if (this.data.aiSearchEnabled) {

                        // reset
                        this.data.ai_status_call_fail = false;
                        this.data.ai_status_show_more = false;
                        this.data.ai_status_clicked_unlike = false;
                        this.data.ai_status_clicked_like = false;
                        this.data.ai_status_final_result = false;
                        this.data.aiSearchDescHeight = -1;
                        this.data.ai_raw_response = "";
                        this.data.ai_response = "";
                        this.data.ai_sources = "";
                        this.data.ai_disclaimer = "";
                        this.data.ai_related_questions = "";
                        this.data.ai_chat_doc_id = undefined;
                        this.data.isFeedbackDisabled = true;
                        this.data.ai_feedback_text = "";
                        this.data.ai_status_feedback_submitted = false;
                        this.data.ai_status_feedback_submitted_error = false;
                        this.data.ai_status_done = false;

                        const tokenResponse = await fetch("/api/beaconstreamtoken", {
                            method: 'POST',
                        });

                        const sseUrl = window.aiStreamUrl;
                        const responseJson = await tokenResponse.json();
                        var prompt = this.data.inputQuery;

                        if (responseJson.success) {
                            this.data.ai_inputTitle = this.data.inputQuery; // set ai title only when submit function is fired
                            
                            const headers = {
                                'Authorization': `Bearer ${responseJson.content.token}`
                            };

                            if (prompt && prompt.length > 0) {
                                const response = await fetch(sseUrl, {
                                    method: 'POST',
                                    headers: headers,
                                    body: JSON.stringify({ "prompt": prompt }),
                                });

                                if (response.ok) {
                                    self.data.ai_status_show_more = false;
                                    self.data.ai_status_final_result = true;

                                    if (window && window.dataLayer) {
                                        window.dataLayer.push({
                                            "event": "search-results-ai",
                                            "pageTemplate": "SearchResults",
                                            "type": "search-results",
                                            "category": "Search Results AI",
                                            "action": prompt.replaceAll('\"', ''),
                                            "label": "AI Result",
                                            "responseType": "AI Response"
                                        });
                                    }

                                    const reader = response.body.getReader();
                                    const decoder = new TextDecoder();
                                    let partialChunk = '';

                                    function processChunk(chunk) {
                                        chunk = partialChunk + chunk;
                                        const events = chunk.split('\n\n');
                                        partialChunk = events.pop();
                                        events.forEach(event => {
                                            const [typeLine, dataLine] = event.split('\n');
                                            const eventType = typeLine?.replace('event: ', '').trim();
                                            const eventData = dataLine?.replace('data: ', '').trim();
                                            if (eventData) processEvent(eventType, eventData);
                                        });
                                    }

                                    function processEvent(type, data) {
                                        const parsedData = JSON.parse(data);
                                        if (type === 'sources') {
                                            for (let i = 0; i < parsedData.sources.length; i++) {
                                                parsedData.sources[i].source_title = parsedData.sources[i].source_title.replace(/\\/g, '');
                                            }
                                            self.data.ai_sources = parsedData.sources;
                                            self.data.ai_disclaimer = parsedData.disclaimer;
                                            self.data.inputQuery = ""; // remove input text
                                            if (parsedData.chat_doc_id)
                                                self.data.ai_chat_doc_id = parsedData.chat_doc_id;
                                        }
                                        else if (type === 'update') {
                                            self.data.ai_raw_response += parsedData.content;
                                            self.data.ai_response = converter.makeHtml(self.data.ai_raw_response);
                                            if (parsedData.chat_doc_id)
                                                self.data.ai_chat_doc_id = parsedData.chat_doc_id;
                                        }
                                        else if (type === 'final_update') {
                                            self.data.ai_response = converter.makeHtml(parsedData.content);
                                            self.data.ai_related_questions = parsedData.related_questions;
                                            if (parsedData.chat_doc_id)
                                                self.data.ai_chat_doc_id = parsedData.chat_doc_id;
                                        }
                                        else if (type === 'done') {
                                            self.data.ai_status_done = true;
                                            reader.cancel();
                                        }
                                    };

                                    reader.read().then(function process({ done, value }) {
                                        if (done) return;
                                        processChunk(decoder.decode(value, { stream: true }));
                                        reader.read().then(process);
                                    });
                                }
                                else {
                                    pushAISearchFail(prompt);
                                }
                            }
                            else {
                                pushAISearchFail(prompt);
                            }
                        }
                        else {
                            pushAISearchFail(prompt);
                        }
                    }
                },
                pushAISearchFail(prompt) {
                    if (window && window.dataLayer) {
                        window.dataLayer.push({
                            "event": "search-results-ai",
                            "pageTemplate": "SearchResults",
                            "type": "search-results",
                            "category": "Search Results AI",
                            "action": prompt.replaceAll('\"', ''),
                            "label": "AI Result",
                            "responseType": "Search Result no AI"
                        });
                    }

                    this.data.ai_status_call_fail = true;
                },

                loadMore() {
                    // console.log("load more");
                    this.data.currentPage = this.data.currentPage + 1;

                    this.data.axiosParams = {
                        ...this.data.axiosParams,
                        page: this.data.currentPage
                    }
                    //console.log(this.data.axiosParams);
                    let self = this;

                    let baseUrl = window.searchAPIUrl;
                    let apiUrl = `${baseUrl}${baseUrl.indexOf('?') > -1 ? '' : '?'}`;
                    // let apiUrl = "http://localhost:3003/searchResults2"; //from json-server

                    axios.get(apiUrl, {
                        params: {
                            ...this.data.axiosParams,
                        }
                    })
                        .then(function (response) {
                            // self.data.results.push(...response.data.results);
                            let results = response.data.results.map((item) => {
                                if (item.title && item.filterText) {
                                    if (item.title.indexOf("<p>") > -1) {
                                        return { ...item, "title": `<p>${item.title.replace("<p>", "")}` }
                                    } else {
                                        return { ...item, "title": `${item.title}` }
                                    }
                                } else {
                                    return { ...item }
                                }
                            });
                            // console.log("LOAD MORE", results);

                            if (results) { self.data.results.push(...results) }
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                },
                submit() {
                    let didyoumeanEl = document.querySelectorAll('.global__didyoumean');
                    let didyoumeanContainer = document.querySelectorAll('.search-results__input-container__didyoumean');
                    didyoumeanContainer.forEach(element => element.classList.remove('show'));

                    didyoumeanEl = document.querySelectorAll('.global__peoplealsosearchedfor');
                    didyoumeanContainer = document.querySelectorAll('.search-results__input-container__peoplealsosearchedfor');
                    didyoumeanContainer.forEach(element => element.classList.remove('show'));

                    this.updateHistory(this.data.inputQuery);
                    this.data.query = this.data.inputQuery;
                    // Set loading icon states

                    this.addLoading();
                    this.getResults();
                },
                prefilter() {
                    let params = getUrlParameter('filters');
                    if (params) {
                        let paramsArray = params.split(',');
                        let filters = [];

                        this.$nextTick(() => {
                            // if has filter params, dump them into filters array
                            paramsArray.forEach((item) => {
                                let name = document.querySelector(`[value="${item}"]`) ? document.querySelector(`[value="${item}"]`).getAttribute('name') : null;

                                filters.push({
                                    value: `${item}`,
                                    name: name
                                });
                            });
                            this.data.filters = filters;
                        });

                    }
                },
                didYouMean(e) {
                    //console.log('didYouMean(',e,')');
                    let query;
                    if (e.target) {
                        query = e.target.innerText;
                    } else {
                        query = e;
                    }
                    //console.log('query = ', query, 'e = ', e, e.target);
                    this.data.inputQuery = query;
                    this.submit();
                },
                updateHistory(q) {
                    let currentParam = "?q=" + getUrlParameter('q');
                    let newUrl = window.location.href.replace(currentParam, "?q=" + encodeURIComponent(q));
                    history.pushState(null, '', newUrl);
                },
                navHistory() {
                    let query = getUrlParameter('q');
                    let filters = getUrlParameter('filters');
                    let didyoumeanEl = document.querySelectorAll('.global__peoplealsosearchedfor');
                    let didyoumeanContainer = document.querySelectorAll('.search-results__input-container__peoplealsosearchedfor');
                    didyoumeanContainer.forEach(element => element.classList.remove('show'));
                    didyoumeanEl = document.querySelectorAll('.global__didyoumean');
                    didyoumeanContainer = document.querySelectorAll('.search-results__input-container__didyoumean');
                    didyoumeanContainer.forEach(element => element.classList.remove('show'));

                    if (query) {
                        this.data.inputQuery = query.replace(/\+/g, " ");
                        this.data.query = query.replace(/\+/g, " ");
                    }

                    if (filters) {
                        this.prefilter();
                    } else {
                        this.getResults();
                    }


                },
                init() {
                    // init is mobile
                    this.data.isMobile = store.state.isMobile;
                    // init saved docs
                    let allSaved = [];
                    let saved = store.state.favorites;

                    for (let prop in saved) {
                        allSaved = [...allSaved, ...saved[prop]];
                    }

                    this.data.savedDocs = allSaved.filter((item) => {
                        return item !== ""
                    });

                    // init filters state
                    this.data.filtersVisible = this.data.isMobile ? false : true; //init 
                    if (window.location.search) {
                        let query = getUrlParameter('q');
                        let filters = getUrlParameter('filters');
                        this.data.inputQuery = query.replace(/\+/g, " ");
                        this.data.query = query.replace(/\+/g, " ");
                        // make api call for results if no filters
                        // otherwise data.filters[] will update and the watcher will trigger 
                        // another api call
                        if (query && !filters) {
                            this.getResults();
                        }
                    }

                    window.onpopstate = () => {
                        this.navHistory();
                    }

                    // listen for filter updates in children
                    EventBus.$on('updateFilters', (el, e, type) => {
                        this.updateFilters(el, e, type);
                    });
                    EventBus.$on('remove-filter', (el, value, type) => {
                        this.removeFilter(el, value, type);
                    });

                    this.initSubmit();


                },
                initSubmit() {
                    let self = this;
                    if (this.data.isMobile) {
                        this.$refs.searchBarMobile.addEventListener("keyup", function (event) {
                            if (event.keyCode === 13) {
                                event.preventDefault();
                                self.submit();
                            }
                        });
                    } else {
                        this.$refs.searchBarDesktop.addEventListener("keyup", function (event) {
                            if (event.keyCode === 13) {
                                event.preventDefault();
                                self.submit();
                            }
                        });
                    }
                },
                clearInput() {
                    this.data.inputQuery = "";
                }
            },
            mounted() {
                this.init();
                if (window.location.search) {
                    this.prefilter();
                }
                if (this.$refs && this.$refs.aiSearchDesc) {
                    this.data.aiSearchDescHeight = this.$refs.aiSearchDesc.offsetHeight;
                }
            },
            updated() {
                var self = this;
                setTimeout(function () {
                    if (self.$refs && self.$refs.aiSearchDesc) {
                        let oldheight = self.data.aiSearchDescHeight;
                        self.data.aiSearchDescHeight = self.$refs.aiSearchDesc.offsetHeight;

                        if (oldheight != self.data.aiSearchDescHeight)
                            self.data.rerenderShowMore++;
                    }
                }, 1000);
            }
        });

        Vue.component('checkbox-item', {
            props: ['data', 'name', 'type', 'filterCategory'],
            data: function () {
                return {
                    id: null,
                    isChecked: false,
                    isActive: null,
                    count: 0,
                    label: null
                }
            },
            watch: {
                "data.filters": function () {
                    this.checkState();
                },
                "data.counts": function () {
                    this.setCount();
                }
            },
            computed: {
                taggingMeta: function () {
                    return JSON.stringify({
                        "type": "search",
                        "category": "Filter",
                        "action": this.filterCategory || "",
                        "label": this.label,
                        "resultCount": this.count ? this.count : ""
                    })
                }
            },
            methods: {
                updateFilters(el, e, type) {
                    EventBus.$emit('updateFilters', el, e, type);
                },
                checkState() {
                    if (this.id == "Saved%20documents%20only") {
                        let item = this.data.filters.find(el => {
                            return encodeURIComponent(el.name) == this.id;
                        });
                        this.isChecked = item ? true : false;
                    } else {
                        let item = this.data.filters.find(el => {
                            return encodeURIComponent(el.value) == this.id;
                        });
                        this.isChecked = item ? true : false;
                    }
                },
                setCount() {
                    //console.log("set count")
                    let paramName = this.$refs.input.value;
                    let countObj = this.data.counts.filter((item) => {
                        return item.filterValue.toString() === paramName;
                    })[0];
                    this.count = countObj ? countObj.count : 0;
                },
                init() {
                    this.label = this.$refs.label.innerText;
                }
            },
            mounted() {
                this.id = encodeURIComponent(this.$refs.input.value);
                this.checkState();
                this.init();
                // this.setCount();
            }
        });

        // AI Search

        Vue.component('ai-input', {
            props: ['data'],
            data: function () {
                return {
                }
            },
            template: `
            <div class="ai-search-desc-title">{{data.ai_inputTitle}}</div>
            `
        });
        Vue.component('ai-disclaimer', {
            props: ['data'],
            data: function () {
                return {
                }
            },
            template: `
            <div>{{data.ai_disclaimer}}</div>
            `
        });
        Vue.component('ai-related-questions', {
            props: ['data'],
            data: function () {
                return {
                }
            },
            template: `
            <div>
                <div class="ai-search-question" v-for="item in data.ai_related_questions">
                    <div v-on:click="searchRelatedQuestion($event)">{{item}}</div>
                </div>
            </div>
            `,
            methods: {
                searchRelatedQuestion(e) {
                    this.data.inputQuery = e.currentTarget.innerText;
                    this.$parent.submit();

                    // Scroll to AI Summary Loading section
                    this.$nextTick(() => {
                        if (this.$parent.$refs && this.$parent.$refs.aiSummary) {
                            this.$parent.$refs.aiSummary.scrollIntoView({ behavior: 'smooth', block: 'start' });
                        }
                    });
                }
            }
        });
        Vue.component('ai-sources', {
            props: ['data'],
            data: function () {
                return {
                }
            },
            template: `
            <div>
                <div class="ai-search-doc-item" v-for="(item, index) in data.ai_sources" :key="index">
                    <span :class="{ attachLink: item.source_url && !item.source_url.includes('badgermeter.widen.net') }"></span>
                    <p data-tag-trigger="click" :data-tag-meta="taggingMetaAI(item.source_title)" v-on:click="imageRedirect(item.source_url)">
                        {{item.source_title}} [{{index + 1}}]
                    </p>
                    <div class="ai-search-doc-item-image" v-on:click="imageRedirect(item.source_url)">
                        <img :src="item.source_thumbnail" data-tag-trigger="click" :data-tag-meta="taggingMetaAI(item.source_title)" />
                    </div>
                </div>
            </div>
            `,
            methods: {
                imageRedirect(e) {
                    window.open(e);
                },
                taggingMetaAI(title) {
                    return JSON.stringify({
                        "pageTemplate": "SearchResults",
                        "type": "search-results",
                        "category": "Search Results AI",
                        "action": `${this.data.ai_inputTitle.replaceAll('\"', '')}` || "",
                        "label": `${title}` || "",
                        "responseType": "AI Response"
                    })
                }
            }
        });

        // results list
        Vue.component('results-list', {
            props: ['data', 'isLoading'],
            data: function () {
                return {
                }
            },
            template: `
            <div class="search-results__cards-content">
                <results-item v-for="(result, index) in data.results" :content="result"  :key="index" :data="data" :isLoading="isLoading"/>
            </div>
            `,
            methods: {
            },

            mounted() {

            }
        });

        // single results item
        Vue.component('results-item', {
            props: ['data', 'content', 'isLoading'],
            data: function () {
                return {
                    resultType: null,
                    seeAll: null, //is "see all" feature enabled,
                    seeAllOpen: null,
                    seeAllLabel: null,//label
                    moreContent: null
                }
            },
            watch: {
                "seeAll": function () {
                    if (this.seeAll) {
                        this.seeAllLabel = this.seeAllOpen ? window.seeLessLabel : window.seeAllLabel;
                    }
                },
                "seeAllOpen": function () {
                    if (this.seeAll) {
                        this.seeAllLabel = this.seeAllOpen ? window.seeLessLabel : window.seeAllLabel;
                    }
                }
            },
            computed: {
                "highlightedCopy": function () {
                    let regex = new RegExp(this.data.query, "gi")
                    if (this.content.description) {
                        let replaceText = this.data.query;
                        const patternMatch = this.content.description.match(regex);
                        if (patternMatch !== null && patternMatch.length > 0) { replaceText = patternMatch[0] }

                        return this.content.description.replace(regex, `<span class="results-card__copy--highlighted">${replaceText}</span>`);
                    }
                },
                "highlightedTitle": function () {
                    let regex = new RegExp(this.data.query, "gi")
                    if (this.content.title) {
                        //console.log("TEST TEST", this.content.title);
                        let replaceText = this.data.query;
                        const patternMatch = this.content.title.match(regex);
                        if (patternMatch !== null && patternMatch.length > 0) { replaceText = patternMatch[0] }

                        return this.content.title.replace(regex, `<span class="results-card__title--highlighted">${replaceText}</span>`);
                    }

                    return this.content.title; // fallback, default to just title
                },
                "newTabLink": function () {
                    return this.content.linkUrl ? this.content.linkUrl.replace('download=true', 'download=false') : null;
                },
                "hrefTarget": function () {
                    if (this.newTabLink) {
                        return this.newTabLink.includes('download=false') ? '_blank' : '_self';
                    }
                },
                "trigger": function () {
                    let trackable;
                    // for (let prop in window.searchFilterValues) {
                    //     if (window.searchFilterValues[prop] == this.content.filterValue) {
                    //         trackable = true;
                    //     }
                    // }
                    return trackable ? "click" : null;
                },
                "taggingMeta": function () {
                    let meta;
                    // if (this.resultType) {
                    //     switch (this.resultType) {
                    //         case 'documentation':
                    //             meta = {
                    //                 "type": "document",
                    //                 "category": "",
                    //                 "label": "",
                    //                 "productLine": "",
                    //                 "language": ""
                    //             }
                    //             break;
                    //         case 'software':
                    //             meta = {
                    //                 "type": "app",
                    //                 "category": "",
                    //                 "label": "",
                    //                 "productLine": "",
                    //                 "language": ""
                    //             }
                    //             break;
                    //         case 'products':
                    //             meta = {    
                    //                 "type": "layer",
                    //                 "category": "Preview Card",
                    //                 "productLine": "",
                    //                 "label": this.content.rawTitle
                    //             }
                    //             break;
                    //         default:
                    //             return;
                    //     }
                    // }

                    return meta ? JSON.stringify(meta) : null;
                }
            },
            template: `
            <div class="results-card">
            <a :href="newTabLink" class="results-card__link" :target="hrefTarget" :data-tag-trigger="trigger" :data-tag-meta="taggingMeta">
                <div class="results-card__wrapper">
                    <div class="results-card__row" :class="{isproduct: content.isProduct}">
                        <div class="results-card__area results-card__area-image" v-if="content.imageUrl">
                            <div class="results-card__image-container">
                                <img :src="content.imageUrl" class="results-card__image">
                            </div>
                        </div>
                        <div class="results-card__area results-card__area-copy">



                            <div class="results-card__title">
                                <span class="results-card__title-content" ref="seeAllContent" v-html="highlightedTitle"></span>
                                <span class="results-card__title-more" v-if="seeAll && seeAllOpen" v-html="moreContent"></span>
                                <a href="#" v-on:click.prevent="toggleSeeAll" v-if="seeAll" v-html="seeAllLabel"></a>
                            </div>


                            <div class="results-card__copy" v-html="highlightedCopy">
                            </div>
                        </div>
                    </div>
                </div>
            </a>
            </div>
            `,
            methods: {
                init() {
                    for (let prop in window.searchFilterValues) {
                        if (window.searchFilterValues[prop] == this.content.filterValue) {
                            this.resultType = prop;
                        }
                    }
                },
                toggleSeeAll() {
                    this.seeAllOpen = !this.seeAllOpen;
                },
                initSeeAll() {
                    if (this.$refs.seeAllContent) {
                        let details = this.$refs.seeAllContent.innerHTML.split(',');
                        this.seeAll = details.length > 3 ? true : false;

                        let truncatedDetails = details.slice(0, 3).join();
                        let moreDetails = details.slice(3).join();

                        this.moreContent = moreDetails;
                        this.$refs.seeAllContent.innerHTML = `${truncatedDetails}${moreDetails == "" ? '' : ','}`;
                    }
                }
            },
            mounted() {
                // this.init();
                this.initSeeAll();

                let self = this;
                this.$nextTick(() => {
                    let trackId = self.data.trackId;

                    if (trackId) {
                        let hitId = self.content.hitId;
                        let query = self.data.query;
                        let url = `/api/SearchHit?q=${encodeURIComponent(query)}&h=${encodeURIComponent(hitId)}&t=${encodeURIComponent(trackId)}`
                        let allAnchors = self.$el.querySelectorAll('a');
                        allAnchors.forEach(el => el.addEventListener('click', (e) =>
                            axios.get(url)
                                .then(function (response) {
                                    //console.log("--> Tracking response: ", response);
                                })
                        ));
                    }
                });

            }
        });

        Vue.component('selectedFilters', {
            props: ['data'],
            data: function () {
                return {
                }
            },
            template: `
                <div class="search-results__selected-filters" :data="data">
                    <div class="filter-label" v-for="filter in data.filters" :key="filter.value" :data-value="filter.value" :data-type="filter.type" v-on:click="removeFilter($event)">
                        <div class="filter-label__wrapper">
                            <span class="filter-label__icon"></span>
                            <span class="filter-label__text">{{filter.name}}</span>
                        </div>
                    </div>
                </div>
            `,
            methods: {
                removeFilter(e) {
                    let type = e.currentTarget.dataset.type;
                    let value = e.currentTarget.dataset.value;
                    // console.log(e.currentTarget);
                    EventBus.$emit('remove-filter', this.data.class, value, type);
                }
            },
            mounted() {

            }
        });

        Vue.component('filter-accordion-template', {
            props: ['data', 'defaultopen'],
            data: function () {
                return {
                    isOpen: (this.defaultopen ? true : false), //is the accordion open
                    seeAllTypesText: false
                }
            },
            computed: {
                productFilters: function () {
                    return this.data.products;
                }
            },
            watch: {
            },
            methods: {
                handleClick() {
                    this.toggleAccordion();
                },

                toggleAccordion() {
                    let contentArea = this.$refs.outerContainer;
                    let contentHeight = this.$refs.innerContainer.getBoundingClientRect().height;

                    if (this.isOpen == true) {
                        this.isOpen = false;

                        requestAnimationFrame(function () {
                            //set content area height to content height to prevent transitioning from auto
                            contentArea.style.maxHeight = contentHeight + 'px';
                            // have the element transition to height: 0
                            requestAnimationFrame(function () {
                                contentArea.style.maxHeight = '0px';
                            });
                        });

                        contentArea.addEventListener('transitionend', () => {
                            contentArea.style.maxHeight = '0';
                        });

                    } else {
                        this.isOpen = true;
                        contentArea.style.maxHeight = contentHeight + "px";
                        contentArea.addEventListener('transitionend', () => {
                            contentArea.style.maxHeight = 'none';
                        });
                    }
                },
                toggleSeeAll() {
                    this.seeAllTypesText = !this.seeAllTypesText
                },
            },
            mounted() {

            }
        });

        new Vue({
            el: `.search-results-${id}`,
            store: store
        }).$mount(`.search-results-${id}`, true);
    }

    if (search.length > 0) {
        search.forEach((item, index) => {
            item.classList.add(`search-results-${index}`);
            searchResultsConstructor(index);
        })
    }

    // window.searchFilterValues = {
    //     documentation: 157,
    //     software: 59,
    //     products: 158
    // }

}

export default searchResults;
